export const environment = {
  production: true,
  resourceApiUrl: 'https://voltageapidev.juunoo.com',
  auth: {
    issuer: 'https://voltageidentitydev.juunoo.com/',
    clientId: 'web-app-dev'
  }
};
